import { REHYDRATE } from 'redux-persist/constants'
import reducers, { generateReducers } from 'reducers'
import initialState from 'careers/initial-state'
import models from 'careers/models'
import * as jobAdActions from 'careers/actions/job-ad'

const { modelReducers, formReducers } = generateReducers(models, initialState)

export default {

  ...reducers,

  careers(state = initialState.careers, action) {
    const newState = { ...state }

    switch (action.type) {
      case REHYDRATE: {
        const { careers: rehydratedState } = action.payload
        if (rehydratedState) {
          return rehydratedState
        }
        break
      }

      case jobAdActions.ADS_REQUEST:
        newState.isFetching = true
        break

      case jobAdActions.ADS_RECEIVE:
        newState.company = action.company
        newState.isFetching = false
        break

      case jobAdActions.SET_UNPUBLISHED:
        newState.unpublished = action.value
        break
    }

    return newState
  },

  ...modelReducers,

  ...formReducers,

}
